import { Check, CheckBox, CheckBoxOutlineBlank, Create } from "@mui/icons-material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { useContext, useState } from "react"
import ConfirmModal from "../../ConfirmModal/ConfirmModal"
import FigmaTable from "../../FigmaTable/FigmaTable"
import moment from 'moment'

const AtasTable = ({ tipo, dados, setIdEdit, filtros }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [confirmFinalizar, setConfirmFinalizar] = useState(false)
    const [idFinalizar, setIdFinalizar] = useState(null)
    const columns = [
        {
            name: 'Data',
            cell: row => row.data_obs
                ? (moment.utc(row.data_obs).format('DD/MM/YY HH:mm'))
                : "Sem data",
            style: {
                width: '7%'
            }
        },
        {
            name: 'Condomínio',
            cell: row => row.condominio
                ? <span title={row.condominio} >{row.id_central}-{row.condominio}</span>
                : "Sem condomínio",
            style: {
                width: '18%'
            }
        },
        {
            name: 'Criado por',
            cell: row => row.nome_usuario
                ? <span title={row.nome_usuario} >{row.nome_usuario}</span>
                : "",
            style: {
                width: '10%'
            }
        },
        {
            name: 'Texto',
            cell: row => row.texto
                ? <span title={row.texto} >{row.texto}</span>
                : "",
            style: {
                width: '25%'
            }
        },
        {
            name: 'Agend.',
            cell: row => row.gerar_evento
                ? <Check sx={{ fontSize: '15px' }} />
                : "",
            style: {
                width: '3%',
                textAlign: 'center'
            }
        },
        {
            name: 'Status',
            cell: row => row.ativo
                ? (<CheckBoxOutlineBlank
                    onClick={() => { setIdFinalizar(row.id); setConfirmFinalizar(true) }}
                    sx={{ fontSize: '18px' }}
                    cursor="pointer"
                    titleAccess={`${tipo == 1 ? "Finalizar observação" : "Finalizar ocorrência"}`}
                />)
                : (<CheckBox
                    sx={{ fontSize: '18px' }}
                    titleAccess={`Finalizado por ${row.nome_usuario_finalizado}`}
                />),
            style: {
                width: '3%',
                textAlign: 'center'
            }
        },
        {
            name: 'Editar',
            cell: (row) => <Create sx={{ cursor: 'pointer', fontSize: '18px' }} onClick={() => { setIdEdit(row.id) }}/>,
            button: true,
            center: true,
            style: {
                width: '1%',
                textAlign: 'center'
            }
        }
    ]

    const getFinalizarObs = (msg) => {
        if (msg.data.status) {
            sendWs("buscarTodasObs", { filtros })
            setConfirmFinalizar(false)
        }
    }

    const finalizarAta = () => {
        addRoute("editarObsLivroAta", getFinalizarObs)
        sendWs("editarObsLivroAta", { observacao: { ativo: false, id: idFinalizar }, filtros })
    }

    // const tamanhoPai = document.getElementById("paiTabela")?.offsetHeight
    // const tamanhoTabela = dados.length * 20

    return (
        <Grid container sx={{ width: '100%', height: '100%', alignContent: 'flex-start', padding: '10px 0px' }} id="paiTabela">
            {confirmFinalizar &&
                <ConfirmModal
                    titleText="Finalizar"
                    open={confirmFinalizar}
                    text="Você deseja finalizar essa observação? Se o evento não foi gerado, será cancelado a geração do mesmo."
                    setOpen={setConfirmFinalizar}
                    cancelFunction={() => setConfirmFinalizar(false)}
                    confirmFunction={finalizarAta}
                />
            }
            <div style={{ display: 'block' }}>
                <h5 style={{ padding: 0, margin: 0 }}>{tipo == "observacao" ? "Observação" : "Ocorrência"}</h5>
            </div>
            {/* <DataTable
                columns={columns}
                data={dados}
                customStyles={customThemeTable}
                fixedHeader={tamanhoPai < tamanhoTabela}
                fixedHeaderScrollHeight={`${tamanhoPai}px`}
                striped
                noDataComponent={<div style={{ height: '50px', fontSize: '30px' }}>Não há dados para exibição</div>}
                // onRowDoubleClicked={(row, event) => dobleClickCallback(extraCallbackParams ? row : row.id)}
            /> */}
            {columns &&
            <FigmaTable data={dados} columns={columns}/>
            }
        </Grid>
    )
}

export default AtasTable
